export default __webpack_public_path__ + "static/media/kitchen3-afterE-1024w.e930bb49.avif";